import piggyLogo from './assets/images/piggy_token_logo.png';

const NewApp: React.FC = () => {
  return (
    <div className="min-h-screen bg-terminal-bg text-terminal-text font-mono flex items-center justify-center p-4">
      <div className="max-w-2xl w-full space-y-6 animate-fade-in">

        {/* Header */}
        <div className="text-center space-y-4">
          <img
            src={piggyLogo}
            alt="PIGGY"
            className="w-20 h-20 mx-auto rounded-full border-2 border-piggy-deep/30"
          />
          <div>
            <h1 className="text-3xl sm:text-4xl font-bold text-piggy-deep tracking-wider glow-text">
              THE PIGGY BBQ
            </h1>
            <p className="text-terminal-muted text-sm mt-2 tracking-wide">
              PIGGY is joining Superform
            </p>
          </div>
        </div>

        {/* Proposal Summary */}
        <div className="terminal-section">
          <div className="terminal-section-header">
            <span className="terminal-title flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-piggy-deep rounded-full"></span>
              PROPOSAL_SUMMARY.md
            </span>
          </div>
          <div className="terminal-section-content text-xs leading-relaxed space-y-3">
            <p className="text-terminal-text">
              The Superform Foundation is acquiring the Piggy brand and sunsetting the PIGGY token
              through a voluntary, onchain conversion mechanism.
            </p>
            <p className="text-terminal-muted">
              PIGGY holders can burn their tokens in exchange for UP at a fixed rate.
              The Piggy brand, community, and spirit will live on as a core cultural layer within Superform.
            </p>
          </div>
        </div>

        {/* Conversion Details */}
        <div className="terminal-section">
          <div className="terminal-section-header">
            <span className="terminal-title flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-terminal-success rounded-full"></span>
              CONVERSION_DETAILS
            </span>
          </div>
          <div className="terminal-section-content text-xs space-y-2">
            <div className="flex justify-between py-1.5 border-b border-terminal-border/30">
              <span className="text-terminal-muted">Exchange Rate</span>
              <span className="text-piggy-deep font-bold">1 PIGGY = 0.0000396 UP</span>
            </div>
            <div className="flex justify-between py-1.5 border-b border-terminal-border/30">
              <span className="text-terminal-muted">Total UP Reserved</span>
              <span className="text-terminal-text font-bold">2,500,000 UP</span>
            </div>
            <div className="flex justify-between py-1.5 border-b border-terminal-border/30">
              <span className="text-terminal-muted">Timeline</span>
              <span className="text-terminal-text">After UP TGE</span>
            </div>
            <div className="flex justify-between py-1.5">
              <span className="text-terminal-muted">Process</span>
              <span className="text-terminal-text">Burn PIGGY &rarr; Receive UP</span>
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="terminal-section">
          <div className="terminal-section-header">
            <span className="terminal-title flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-terminal-info rounded-full"></span>
              LINKS
            </span>
          </div>
          <div className="terminal-section-content text-xs space-y-2">
            <a
              href="https://www.superform.xyz/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between py-1.5 border-b border-terminal-border/30 hover:bg-terminal-header/30 px-1 -mx-1 transition-colors"
            >
              <span className="text-terminal-muted">
                <span className="text-piggy-deep/60">./</span> Superform
              </span>
              <span className="text-piggy-deep">superform.xyz &rarr;</span>
            </a>
            <a
              href="https://discord.com/channels/996852112401125446/1466823251564040274"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between py-1.5 border-b border-terminal-border/30 hover:bg-terminal-header/30 px-1 -mx-1 transition-colors"
            >
              <span className="text-terminal-muted">
                <span className="text-piggy-deep/60">./</span> Proposal Discussion
              </span>
              <span className="text-piggy-deep">Discord &rarr;</span>
            </a>
            <a
              href="https://piggydao.xyz"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between py-1.5 hover:bg-terminal-header/30 px-1 -mx-1 transition-colors"
            >
              <span className="text-terminal-muted">
                <span className="text-piggy-deep/60">./</span> PiggyDAO
              </span>
              <span className="text-piggy-deep">piggydao.xyz &rarr;</span>
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center space-y-3 pt-2 pb-8">
          <p className="text-terminal-muted text-xs">
            Thank you for being part of the PIGGY community.
          </p>
          <p className="text-piggy-deep text-sm font-bold tracking-wide">
            Long live PIGGY.
          </p>
          <p className="text-terminal-muted text-xs">
            Built by{' '}
            <a
              href="https://x.com/davyjones0x"
              target="_blank"
              rel="noopener noreferrer"
              className="text-piggy-deep hover:text-piggy-deep/80 transition-colors"
            >
              @davyjones0x
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewApp;
